import { StreamActions, StreamElement } from '@hotwired/turbo'

StreamActions.modify_classes = function (this: StreamElement) {
  const targets = document.querySelectorAll<HTMLElement>(this.target ? `#${this.target}` : this.targets)
  const classesToAdd = classArray(this.getAttribute('add'))
  const classesToRemove = classArray(this.getAttribute('remove'))
  const classesToToggle = classArray(this.getAttribute('toggle'))

  if (!classesToAdd.length && !classesToRemove.length && !classesToToggle.length) {
    return console.warn(
      'The `modify_classes` Turbo Stream action requires an `add`, `remove`, and/or `toggle` attribute.',
    )
  }

  if (!targets.length) {
    return console.warn('The `modify_classes` Turbo Stream action requires a `target` or `targets` to be specified.')
  }

  targets.forEach(target => {
    if (classesToAdd.length) target.classList.add(...classesToAdd)
    if (classesToRemove.length) target.classList.remove(...classesToRemove)
    if (classesToToggle.length)
      classesToToggle.forEach(className => {
        target.classList.toggle(className)
      })
  })
}

function classArray(classes?: string) {
  return classes?.length ? classes.split(' ') : []
}
